//import companyAdminInfo from './get';
import get from './get';
import update from './update';
import suspend from './suspend';
import reactivate from './reactivate';

export default [get, update, suspend, reactivate];
//export default [companyAdminInfo];
